const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/workouts/index.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/workouts/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { getActiveWorkoutQuery } from '@/features/workouts/lib/get-active-workout.query';
import { listWorkoutTemplatesQuery } from '@/features/workouts/lib/list-workout-templates.query';
import { WorkoutsSkeleton } from '@/features/workouts/ui/workouts-skeleton';
export const Route = createFileRoute('/_authenticated/tracking/workouts/')({
  loader: async ({
    context,
    location
  }) => {
    const deps = {
      controllers: {
        workoutController: context.deps.controllers.workoutController
      }
    };
    try {
      await Promise.all([context.queryClient.ensureInfiniteQueryData(listWorkoutTemplatesQuery(deps)), context.queryClient.ensureQueryData(getActiveWorkoutQuery(deps))]);
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  pendingComponent: WorkoutsSkeleton
});